import * as THREE from "three";
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';


export function InitScene(_config) {
	this.scene = new THREE.Scene();
	this.backScene = new THREE.Scene();

	if (_config.viewer.backgroundTextureEnabled) {

		this.backScene.background = this.textureList["sceneBackground"];
		this.backScene.background.encoding = THREE.sRGBEncoding;

	}

	this.camera = new THREE.PerspectiveCamera(
		_config.viewer.cameraSetting.fov,
		this.divRef.current.offsetWidth / this.divRef.current.offsetHeight,
		0.6,
		_config.viewer.cameraSetting.frustum
	);
}

export function InitRenderer(_config, _isMobile) {
	let customRatio;
	let ratio = window.devicePixelRatio;

	if (ratio > 1) {
		customRatio = ratio;
	} else {
		if (_isMobile) {
			customRatio = ratio * 0.82;
		} else {
			customRatio = _config.viewer.renderer.ratioDivisor;
		}
	}

	this.renderer = new THREE.WebGLRenderer({
		antialias: true,
		preserveDrawingBuffer: false,
		stencil: false,
		powerPreference: "high-performance"
		//precision:"mediump",
	});
	this.renderer.setPixelRatio(customRatio);

	this.renderer.setSize(this.divRef.current.offsetWidth, this.divRef.current.offsetHeight);

	this.renderer.outputEncoding = THREE.sRGBEncoding;
	this.renderer.physicallyCorrectLights = true;
	this.renderer.shadowMap.enabled = true;

	if (_config.viewer.renderer.shadowMapType.indexOf("VSM", 0) !== -1) {
		this.renderer.shadowMap.type = THREE.VSMShadowMap;
	}
	if (_config.viewer.renderer.shadowMapType.indexOf("PCFSoft", 0) !== -1) {
		this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
	}
	if (_config.viewer.renderer.shadowMapType.indexOf("PCFShadow", 0) !== -1) {
		this.renderer.shadowMap.type = THREE.PCFShadowMap;
	}
}


let dracoLoader;
function getDracoLoader() {
	if (!dracoLoader) {
		dracoLoader = new DRACOLoader();
		dracoLoader.setDecoderConfig({ type: 'js' });
		dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
	}
	return dracoLoader;
}

let gltfLoader;
export function getGltfLoader() {
	if (!gltfLoader) {
		gltfLoader = new GLTFLoader();
		gltfLoader.setDRACOLoader(getDracoLoader()).setCrossOrigin('anonymous');
	}
	return gltfLoader;
}